interface SurveyChoice {
  text: string;
  value: string;
}

interface SurveyElement {
  name: string;
  type: string;
  title: string;
  choices?: SurveyChoice[];
}

interface SurveyPage {
  name: string;
  elements: SurveyElement[];
}

interface SurveySchema {
  pages: SurveyPage[];
}

export const findQuestionDetails = (
  surveySchema: string | object,
  questionName: string,
): { title: string; choices?: SurveyChoice[] } | null => {
  try {
    if (!surveySchema) return null;

    const schema: SurveySchema =
      typeof surveySchema === "string"
        ? JSON.parse(surveySchema)
        : surveySchema;

    const allElements = schema.pages?.flatMap((page) => page.elements) || [];
    const question = allElements.find(
      (element) => element.name === questionName,
    );

    return question
      ? {
          title: question.title,
          choices: question.choices,
        }
      : null;
  } catch (error) {
    console.error("Error parsing survey schema:", error);
    return null;
  }
};

export const getAnswerText = (
  questionDetails: { choices?: SurveyChoice[] },
  answerValue: string,
): string => {
  if (!questionDetails?.choices) return answerValue;

  const choice = questionDetails.choices.find(
    (c) => c.value.toLowerCase() === answerValue.toLowerCase(),
  );
  console.log("5 choice", choice);
  console.log("5 answerValue", answerValue);
  console.log("5 result", choice ? choice.text : answerValue);
  return choice ? choice.text : answerValue;
};
